import { atom } from "jotai";

// Breakpoints mirror use-mobile.tsx. Seed from the viewport synchronously at
// module load so the first render is already correct — otherwise these start
// `false` and `useIsMobile`/`useIsWide` only correct them in a post-mount
// effect, so mobile-gated UI paints the desktop layout for one frame and then
// swaps (a visible flash on every mobile load). The hooks still keep these in
// sync on resize.
const MOBILE_BREAKPOINT = 768;
const WIDE_BREAKPOINT = 1024;
const hasWindow = typeof window !== "undefined";

export const isMobileAtom = atom(hasWindow && window.innerWidth < MOBILE_BREAKPOINT);
export const isWideAtom = atom(hasWindow && window.innerWidth >= WIDE_BREAKPOINT);
